export default __webpack_public_path__ + "static/media/thomas-edison.05a8d8d2.png";